import { useState, useEffect, useContext } from "react";
import MenuServices from "services/MenuServices";
import { AdminContext } from "context/AdminContext";

const useSidebar = () => {
  const [sidebar, setSidebar] = useState([]); // Store menu data
  const [, setLoading] = useState(true); // Loading state
   const {  dispatch } = useContext(AdminContext);
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await MenuServices.getAllAdminMenu();
        if (response.status) {
          setSidebar(response.data);
        } else {
          console.error("Response status is false:", response);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) { 
          dispatch({ type: "USER_LOGOUT" });
      }
       
        console.error("Failed to fetch menu data:", error);
      } finally {
        setLoading(false); // Ensure loading state is updated
      }
    };

    fetchMenu();
    // eslint-disable-next-line
  }, []);

  return { sidebar }; // Return only data, not JSX
};

export default useSidebar;
